import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ConfigContext from '../../../contexts/ConfigContext';

import ResponsiveImg from '../../shared/ResponsiveImg';

import styles from './CateringCta.module.postcss';

function CateringCta({ logo, title }) {
  const { vehicle_type } = useContext(ConfigContext);

  return (
    <div className={styles.CateringCta}>
      <ResponsiveImg
        className={styles.CateringCta_img}
        src='https://static.seattlefoodtruck.com/photos/book-catering.webp'
        widths={[200, 400, 800]}
        sizes='(max-width: 900px) 100vw, 25vw'
        alt='Book catering for your event'
        loading='lazy'
      />
      <div className={styles.CateringCta_content}>
        <h3 className='u-mb0 u-phosphate'>{ title || 'Planning an Event?'}</h3>
        <ul>
          <li>Free, no-obligation quotes tailored to your event</li>
          <li>Access to hundreds of top food {vehicle_type.toLowerCase()}s in your area</li>
          <li>Effortless way to make your event unique and memorable</li>
        </ul>
        <Link to='/catering' className='Button Button--wide Button--mobile-w100'>
          Book Your Food {vehicle_type} Catering
        </Link>
      </div>

      { logo &&
        <img
          className={styles.CateringCta_logo}
          src={logo}
          alt='Truck logo'
        />
      }
    </div>
  );
}

CateringCta.propTypes = {
  logo: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
};

export default CateringCta;
